const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        page: {
          title: "Indicadores de atención",
          subtitleAll: "Visión general de todas las conversaciones de la operación.",
          subtitleOwn: "Tus indicadores de atención.",
          period: {
            label: "Período",
            today: "Hoy",
            last7: "Últimos 7 días",
            last30: "Últimos 30 días",
            month: "Mes actual",
            custom: "Personalizado",
            from: "Desde",
            to: "Hasta",
          },
          filters: {
            queue: "Cola",
            allQueues: "Todas las colas",
            attendant: "Agente",
            allAttendants: "Todos los agentes",
          },
          errors: {
            invalidDates: "Ingresa fechas válidas.",
            endBeforeStart: "La fecha final debe ser igual o posterior a la inicial.",
            tooLong: "El período máximo es de 366 días.",
          },
          cards: {
            conversations: "conversaciones medidas",
            open: { label: "En atención ahora", hint: "Tickets abiertos en este momento, sin importar el período." },
            pending: { label: "En espera ahora", hint: "Tickets en la cola esperando que alguien los acepte, ahora." },
            unanswered: { label: "Sin respuesta", hint: "Tickets del período donde el cliente escribió y nadie respondió todavía." },
            created: { label: "Conversaciones iniciadas", hint: "Tickets creados en el período. Una conversación reabierta en el mismo ticket no se cuenta de nuevo. Los grupos no entran." },
            closed: { label: "Resueltos", hint: "Tickets finalizados dentro del período." },
            firstResponse: { label: "1ª respuesta (promedio)", hint: "Tiempo entre el primer mensaje del cliente y nuestro primer mensaje. Las respuestas del agente automático cuentan. Los tickets iniciados por nosotros no entran." },
            handling: { label: "Tiempo de atención (aprox.)", hint: "Desde la creación del ticket hasta la última actualización de los tickets resueltos en el período. Es una aproximación: cualquier cambio posterior altera el número." },
            ratings: "valoraciones",
            rating: { label: "Valoración media", hint: "Promedio de las notas (1 a 5) dadas por los clientes en las atenciones resueltas en el período. Solo cuentan quienes respondieron." },
            ratingRate: { label: "Respuestas a la valoración", hint: "De las atenciones resueltas en el período en que se pidió valoración, cuántos clientes respondieron." },
            newContacts: { label: "Nuevos contactos", hint: "Contactos registrados en el período (sin grupos)." },
          },
          charts: {
            byHour: "Inicio de atenciones por hora del día",
            ratings: "Notas recibidas",
            closeReasons: "Motivos de cierre",
            perDay: "Conversaciones iniciadas por día",
            perQueue: "Por cola",
            perAttendant: "Por agente",
          },
          table: {
            rating: "Nota",
            attendant: "Agente",
            created: "Iniciadas",
            closed: "Resueltas",
            firstResponse: "1ª respuesta (promedio)",
          },
          noReason: "Sin motivo",
          noRatings: "Ninguna valoración en este período.",
          noQueue: "Sin cola",
          noAttendant: "Sin agente (en cola)",
          empty: "No hay conversaciones en este período.",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          botEnabled: "Agente Rose activo en esta conexión",
          ignoreGroups: "Ignorar grupos de WhatsApp",
        },
        hours: {
          enabled: "Definir horario de atención",
          help: "Fuera de horario, Rose sigue atendiendo y avisa que el equipo responde en horario laboral. Sin Rose, el cliente recibe el aviso de abajo (una vez cada 12 horas).",
          timezone: "Zona horaria",
          closed: "Cerrado",
          holidays: "Feriados y días sin atención",
          holidaysHelp: "Una fecha por línea, formato AAAA-MM-DD (ej.: 2026-12-25).",
          message: "Aviso fuera de horario",
          messageHelp: "Se envía al cliente que escribe fuera de horario. Déjalo vacío para no enviar aviso. Acepta {{name}}.",
          days: { 0: "Domingo", 1: "Lunes", 2: "Martes", 3: "Miércoles", 4: "Jueves", 5: "Viernes", 6: "Sábado" },
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        noPhone: "Sin teléfono",
        lidHint: "LID: identificador interno de WhatsApp, usado cuando no se revela el teléfono.",
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      hermes: {
        handoffReason: {
          cliente: "Rose: el cliente pidió una persona",
          modelo: "Rose: el agente pasó al equipo",
          erro: "Rose: el agente falló y pasó al equipo",
          ventana: "Rose: se agotó el tiempo de respuesta",
          hostilidade: "Rose: cliente molesto, atención",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        lidOnlyHint: "El campo de arriba guarda el LID, no un teléfono. Informe el teléfono real con código de país y área para identificar el contacto.",
        lidHint: "Identificador interno de WhatsApp, guardado junto al teléfono.",
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        botHeader: "Bot",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
          peek: "Espiar conversación",
        },
        peek: {
          subtitle: "Espiando (solo lectura, el cliente no ve que lo abriste)",
          close: "Cerrar",
          empty: "Sin mensajes",
          loading: "Cargando…",
          latest: "Mostrando los últimos mensajes",
          customer: "Cliente",
          team: "Bot / equipo",
          media: "[medio]",
          deleted: "mensaje eliminado",
          noQueue: "Sin cola",
          botActive: "Bot activo",
          waiting: "En espera",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      lab: {
        title: "Laboratorio de Rose",
        hint: "Clientes simulados conversan con Rose en un entorno de prueba (nada se envía por WhatsApp ni se altera ninguna atención real). Cada escenario se evalúa con criterios fijos: si transfirió, el motivo, qué contiene la respuesta y su tamaño. Ejecútelo antes y después de cambiar el agente.",
        scenarios: "Escenarios",
        results: "Resultados",
        builtin: "estándar",
        noRuns: "Aún no se ejecutó ninguna prueba.",
        pickOne: "Marque al menos un escenario.",
        turnsCount: "{{count}} mensaje(s) del cliente",
        running: "Ejecutando… {{done}} de {{total}} escenarios",
        summary: "{{passed}} de {{total}} escenarios pasaron",
        customer: "Cliente",
        agent: "Rose",
        handedOff: "Transfirió al equipo",
        scenarioSaved: "Escenario guardado.",
        scenarioDeleted: "Escenario eliminado.",
        deleteTitle: "Eliminar escenario",
        deleteMessage: "Este escenario será eliminado. Los resultados anteriores se conservan.",
        status: { pass: "Pasó", fail: "Falló", error: "Error" },
        handoff: { any: "Da igual transferir", required: "Debe transferir", forbidden: "No debe transferir" },
        hours: { open: "Horario: abierto", closed: "Horario: cerrado (simulado)", real: "Horario real de la conexión" },
        reason: { cliente: "Cliente pidió", modelo: "Agente decidió", erro: "Error", ventana: "Tiempo agotado", hostilidade: "Hostilidad" },
        buttons: { new: "Nuevo escenario", run: "Ejecutar seleccionados", duplicate: "Duplicar", save: "Guardar", cancel: "Cancelar" },
        modal: {
          titleNew: "Nuevo escenario",
          titleEdit: "Editar escenario",
          name: "Nombre",
          turns: "Mensajes del cliente",
          turnsHelp: "Uno por línea (hasta 6). Si Rose transfiere, los siguientes no se envían.",
          hours: "Horario de atención simulado",
          hoursHelp: "Se informa a Rose junto con el mensaje.",
          expectTitle: "Qué esperar de Rose",
          handoff: "Transferencia al equipo",
          reasonsHelp: "Motivos aceptados si transfiere (vacío = cualquiera):",
          mustContain: "La respuesta debe contener",
          mustNotContain: "La respuesta no puede contener",
          termsHelp: "Un término por línea; ignora mayúsculas y acentos.",
          minReplies: "Mín. respuestas",
          maxReplies: "Máx. respuestas",
          maxReplyChars: "Máx. caracteres",
          timeout: "Espera (s)",
        },
      },
      campaigns: {
        title: "Campañas",
        hint: "Envíos masivos con pausa aleatoria entre mensajes, límite por hora y franja horaria. Escribe solo a quienes aceptaron ser contactados.",
        empty: "Aún no hay campañas. Crea la primera para empezar.",
        optOutNotice: "Para no recibir más mensajes, responde SALIR.",
        buttons: {
          add: "Nueva campaña",
          details: "Detalles",
          start: "Iniciar",
          pause: "Pausar",
          resume: "Reanudar",
          cancel: "Cancelar campaña",
          delete: "Eliminar",
          close: "Cerrar",
          review: "Revisar",
          keepDraft: "Dejar como borrador",
        },
        table: {
          name: "Nombre",
          status: "Estado",
          progress: "Progreso",
          sent: "Enviadas",
          remaining: "Restantes",
          actions: "Acciones",
        },
        status: {
          draft: "Borrador",
          running: "Enviando",
          paused: "Pausada",
          completed: "Completada",
          canceled: "Cancelada",
        },
        recipientStatus: {
          pending: "En cola",
          sent: "Enviada",
          failed: "Falló",
          invalid: "Sin WhatsApp",
          skipped: "Omitida",
        },
        toasts: {
          started: "Campaña iniciada.",
          deleted: "Campaña eliminada.",
        },
        confirm: {
          cancel: {
            title: "Cancelar la campaña",
            message: "Los mensajes aún no enviados se descartarán. Lo ya enviado no se puede deshacer.",
          },
          delete: {
            title: "Eliminar la campaña",
            message: "El historial de envíos de esta campaña se borrará.",
          },
        },
        details: {
          estimate: "tiempo restante estimado: {{time}} (sin contar la franja horaria)",
          finished: "finalizada",
          message: "Mensaje",
          settings: "De {{min}} a {{max}} s entre mensajes · hasta {{hourly}} por hora",
          window: "solo de {{start}} a {{end}}",
          started: "Inicio",
          finishedAt: "Fin",
          filter: "Mostrar",
          all: "Todos",
          name: "Nombre",
          number: "Número",
          status: "Estado",
          sentAt: "Enviada el",
          more: "Cargar más",
        },
        modal: {
          title: "Nueva campaña",
          reviewTitle: "Revisar antes de enviar",
          name: "Nombre de la campaña",
          connection: "Conexión que enviará",
          connectionOffline: "Esta conexión no está conectada ahora. El envío solo empieza cuando lo esté.",
          audience: "Quién recibe",
          audienceAll: "Todos los contactos (excepto grupos y quienes pidieron salir)",
          audienceContacts: "Elegir contactos",
          audienceTag: "Contactos con una etiqueta",
          chooseTag: "Elige la etiqueta",
          noTags: "No hay etiquetas. Créalas en Contactos > Etiquetas.",
          audienceNumbers: "Pegar una lista de números",
          searchContacts: "Buscar contactos",
          noContacts: "No se encontraron contactos",
          numbersHint: "Uno por línea: solo el número, o nombre;número. Los números sin código de país se tratan como brasileños (55).",
          message: "Mensaje",
          messageHint: "Usa [[firstName]] o [[name]] y variaciones como {Hola|Buenas|Qué tal}",
          preview: "Vista previa (ejemplo)",
          optOutNotice: "Añadir aviso para salir (\"responde SALIR\") al final del mensaje",
          pace: "Ritmo de envío",
          minDelay: "Pausa mínima (s)",
          maxDelay: "Pausa máxima (s)",
          hourlyLimit: "Máx. por hora",
          paceHint: "La pausa entre mensajes se sortea entre el mínimo y el máximo (mínimo permitido: {{min}} s). Un ritmo más lento reduce el riesgo de bloqueo del número.",
          useWindow: "Enviar solo en cierto horario",
          windowStart: "Desde",
          windowEnd: "Hasta",
          scheduledAt: "Empezar el (opcional)",
          scheduledHint: "Vacío: empieza en cuanto la inicies.",
        },
        review: {
          ready: "{{count}} destinatarios listos para recibir.",
          optOut: "{{count}} omitidos porque pidieron no recibir mensajes.",
          invalid: "{{count}} líneas/contactos con número inválido fueron omitidos.",
          duplicates: "{{count}} repetidos fueron omitidos.",
          estimate: "Tiempo estimado: {{time}} (sin contar la franja horaria).",
          warning: "Una vez iniciada, lo ya enviado no se puede deshacer. Puedes pausar o cancelar en cualquier momento.",
        },
        optOutBadge: "No quiere campañas",
        optOutOn: "Marcar como que no quiere campañas",
        optOutOff: "Permitir campañas de nuevo",
      },
      tags: {
        title: "Etiquetas",
        manage: "Etiquetas",
        filter: "Etiqueta",
        filterAll: "Todas",
        contactTitle: "Etiquetas del contacto",
        select: "Etiquetas",
        noneCreated: "Aún no hay etiquetas. Un administrador las crea en Contactos > Etiquetas.",
        newName: "Nueva etiqueta",
        editName: "Nombre de la etiqueta",
        empty: "Aún no hay etiquetas.",
        contactsCount: "{{count}} contacto",
        contactsCount_plural: "{{count}} contactos",
        confirmDelete: "¿Eliminar la etiqueta \"{{name}}\"? Se quitará de todos los contactos.",
        toasts: {
          deleted: "Etiqueta eliminada.",
        },
        buttons: {
          add: "Añadir",
          save: "Guardar",
          cancelEdit: "Cancelar edición",
          close: "Cerrar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          campaigns: "Campañas",
          lab: "Laboratorio",
          schedules: "Programados",
          supervisor: "Supervisor",
          protocols: "Protocolos",
          funnel: "Embudo",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Linhas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
          darkMode: "Modo oscuro",
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      funnel: {
        title: "Embudo de oportunidades",
        new: "Nueva oportunidad",
        search: "Buscar oportunidad o contacto",
        owner: "Responsable",
        allOwners: "Todos",
        noOwner: "Sin responsable",
        emptyStage: "Ninguna oportunidad en esta etapa.",
        truncated: "Mostrando las {{total}} más recientes. Use la búsqueda para ver el resto.",
        menu: "Opciones",
        moveTo: "Mover a {{stage}}",
        delete: "Eliminar",
        deleted: "Oportunidad eliminada.",
        confirmDeleteTitle: "Eliminar oportunidad",
        confirmDeleteMessage: "La oportunidad y sus tareas serán eliminadas. La atención y el contacto no se ven afectados.",
        kind: {"open": "En curso", "won": "Ganada", "lost": "Perdida"},
        summary: {
          open: "{{total}} abiertas",
          openValue: "Abiertas: {{total}}",
          won: "{{total}} ganadas",
          wonValue: "Ganado: {{total}}",
          rate: "Tasa de cierre: {{total}}%",
          noRate: "Tasa de cierre: sin datos",
        },
        card: {"overdue": "{{total}} vencida(s)", "tasks": "{{total}} tarea(s)"},
        alerts: {
          button: "Alertas ({{total}})",
          taskOverdue: "Tarea vencida",
          stale: "Detenida",
          days: "{{total}} día(s) en la etapa",
        },
        dialog: {
          newTitle: "Nueva oportunidad",
          editTitle: "Oportunidad",
          title: "Título",
          contact: "Contacto",
          contactHint: "Escriba al menos 3 letras del nombre o número",
          pickContact: "Elija el contacto de la oportunidad.",
          value: "Valor (R$)",
          stage: "Etapa inicial",
          firstStage: "Primera etapa",
          owner: "Responsable",
          me: "Yo",
          notes: "Observaciones",
          openTicket: "Abrir atención",
          saved: "Oportunidad guardada.",
          cancel: "Cancelar",
          save: "Guardar",
        },
        tasks: {
          title: "Tareas",
          empty: "Sin tareas. Registre el próximo paso para no perder el plazo.",
          new: "Nueva tarea",
          due: "Plazo",
          add: "Agregar",
          remove: "Quitar tarea",
          noDue: "Sin plazo",
          overdue: "Vencida",
        },
        stages: {
          button: "Etapas",
          title: "Etapas del embudo",
          hint: "Las etapas \"en curso\" pueden avisar cuando una oportunidad queda detenida más de lo permitido. Las etapas \"ganada\" y \"perdida\" cierran la oportunidad.",
          name: "Nombre",
          color: "Color",
          kind: "Tipo",
          staleDays: "Alertar tras (días)",
          save: "Guardar",
          saved: "Etapa guardada.",
          up: "Subir",
          down: "Bajar",
          remove: "Eliminar etapa",
          add: "Agregar etapa",
          newName: "Nueva etapa",
          close: "Cerrar",
        },
      },
      protocols: {
        title: "Protocolos y valoraciones",
        export: "Exportar CSV",
        truncated: "La exportación se limitó a las {{rows}} filas más recientes. Usa los filtros para reducirla.",
        summary: { total: "Cerradas", rated: "Valoradas", average: "Valoración media", low: "Notas 1 y 2" },
        hintAdmin: "Atenciones cerradas, con protocolo, motivo y nota del cliente. La fecha de cierre es aproximada (última actualización de la atención). Las notas 1 y 2 se destacan para seguimiento.",
        hintOwn: "Tus atenciones cerradas, con protocolo, motivo y nota del cliente.",
        search: "Buscar protocolo o contacto",
        filters: {
          from: "Cerrada desde",
          to: "Hasta",
          rating: "Nota",
          anyRating: "Cualquiera",
          reason: "Motivo",
          allReasons: "Todos",
          noReason: "Sin motivo",
          queue: "Cola",
          allQueues: "Todas",
          noQueue: "Sin cola",
          attendant: "Agente",
          allAttendants: "Todos",
          connection: "Conexión",
          allConnections: "Todas",
        },
        ratingFilter: { rated: "Valoradas", unrated: "Sin valoración", low: "Bajas (1 y 2)", "5": "Nota 5", "4": "Nota 4", "3": "Nota 3", "2": "Nota 2", "1": "Nota 1" },
        table: { protocol: "Protocolo", contact: "Contacto", attendant: "Agente", queue: "Cola", reason: "Motivo", rating: "Nota", closedAt: "Cerrada el", actions: "Acciones" },
        empty: "Ninguna atención cerrada con estos filtros.",
        openTicket: "Abrir atención",
        perPage: "Por página",
      },
      supervisor: {
        title: "Supervisor",
        hint: "Atenciones abiertas y en espera, de la más parada a la más reciente. Marca las que quieres tratar y usa las acciones masivas (hasta {{max}} a la vez). Estas acciones nunca envían nada al cliente.",
        search: "Buscar contacto o mensaje",
        summary: { open: "En atención", pending: "En espera" },
        status: { open: "En atención", pending: "En espera" },
        filters: {
          status: "Estado",
          allStatus: "Todas",
          queue: "Cola",
          allQueues: "Todas",
          noQueue: "Sin cola",
          attendant: "Agente",
          allAttendants: "Todos",
          noAttendant: "Sin agente",
          connection: "Conexión",
          allConnections: "Todas",
          idle: "Paradas hace",
          anyIdle: "Cualquier tiempo",
          idleAtLeast: "Al menos {{time}}",
          unread: "Solo con no leídos",
        },
        table: {
          contact: "Contacto",
          lastMessage: "Último mensaje",
          status: "Estado",
          attendant: "Agente",
          queue: "Cola",
          idle: "Parada hace",
          actions: "Acciones",
        },
        nobody: "Nadie",
        empty: "Ninguna atención con estos filtros.",
        openTicket: "Abrir atención",
        selectPage: "Seleccionar todas de esta página",
        selected: "{{total}} seleccionada(s) (máx. {{max}})",
        clear: "Limpiar selección",
        limit: "Límite de {{max}} atenciones a la vez.",
        perPage: "Por página",
        result: "{{done}} hecha(s), {{skipped}} omitida(s), {{failed}} con error.",
        transfer: {
          user: "Agente de destino",
          noUser: "Ninguno (volver a la cola)",
          queue: "Cola de destino",
          keepQueue: "Mantener la cola actual",
          help: "Con agente, la atención pasa a \"En atención\". Solo con cola, vuelve a \"En espera\" en esa cola.",
        },
        actions: {
          transfer: {
            button: "Transferir",
            title: "Transferir {{total}} atención(es)",
            description: "Elige el agente y/o la cola. Cada atención recibe una nota interna con la transferencia.",
            confirm: "Transferir",
          },
          unassign: {
            button: "Devolver a la cola",
            title: "Devolver {{total}} atención(es) a la cola",
            description: "Las atenciones quedan sin agente y vuelven a \"En espera\", en la misma cola.",
            confirm: "Devolver",
          },
          close: {
            button: "Resolver",
            title: "Resolver {{total}} atención(es)",
            description: "Las atenciones se cierran sin mensaje de despedida ni solicitud de valoración al cliente. Si escribe después, vuelve a la cola con normalidad.",
            confirm: "Resolver",
          },
          markRead: {
            button: "Marcar como leído",
            title: "Marcar {{total}} atención(es) como leída(s)",
            description: "Pone a cero los no leídos en el panel. No envía confirmación de lectura al cliente.",
            confirm: "Marcar como leído",
          },
        },
      },
      schedules: {
        title: "Mensajes programados",
        hintAdmin: "Todos los mensajes programados por el equipo. Los pendientes se pueden cancelar; los que fallaron se pueden reintentar. Para programar, usa el reloj dentro de la atención.",
        hintOwn: "Mensajes que programaste. Para programar, usa el reloj dentro de la atención.",
        search: "Buscar por contacto, número o texto",
        filters: {
          status: "Estado",
          all: "Todos",
          connection: "Conexión",
          allConnections: "Todas",
          createdBy: "Programado por",
          everyone: "Todos",
          from: "Desde",
          to: "Hasta",
        },
        table: {
          contact: "Contacto",
          message: "Mensaje",
          sendAt: "Envío",
          status: "Estado",
          connection: "Conexión",
          createdBy: "Programado por",
          actions: "Acciones",
        },
        empty: "Ningún mensaje programado con estos filtros.",
        openTicket: "Abrir atención",
        retry: "Reintentar",
        cancel: "Cancelar envío",
        confirmCancelTitle: "¿Cancelar este mensaje programado?",
        canceled: "Mensaje programado cancelado.",
        retried: "Mensaje en cola para envío.",
      },
      schedule: {
        title:"Programar mensaje",
        message: "Mensaje",
        when: "Enviar el",
        repeat: "Repetir",
        hint: "El mensaje sale por la conexión de esta atención. Si la conexión está sin conexión, el sistema reintenta hasta 3 veces.",
        saved: "Mensaje programado.",
        list: "Programados en esta atención",
        empty: "Ningún mensaje programado.",
        close: "Cerrar",
        save: "Programar",
        status: {
          pending: "Pendiente",
          sent: "Enviado",
          failed: "Falló",
          canceled: "Cancelado",
        },
        recurrence: {
          none: "Una vez",
          daily: "Todos los días",
          weekly: "Cada semana",
          monthly: "Cada mes",
        },
        followUpEnabled: "Seguimiento automático cuando el cliente deja de responder",
        followUpAfter: "Minutos de silencio (mín. 30)",
        followUpMax: "Máx. de seguimientos (1 a 3)",
        followUpMessage: "Mensaje de seguimiento",
        followUpHelp: "Use {{name}} para el nombre. Solo se envía en horario de atención, en atenciones sin bot, y se detiene cuando el cliente responde o pide salir. Vacío usa el texto predeterminado.",
      },
      quality: {
        closeTitle: "Cerrar atención",
        reason: "Motivo del cierre",
        reasonRequired: "Obligatorio: elija un motivo para cerrar.",
        reasonOptional: "Opcional: elija un motivo o cierre sin él.",
        reasonNone: "Sin motivo",
        confirm: "Cerrar",
        cancel: "Cancelar",
        notes: "Notas internas",
        notesHint: "Visibles solo para el equipo. El cliente no las recibe.",
        notesPlaceholder: "Escriba una nota...",
        notesAdd: "Agregar",
        notesEmpty: "Aún no hay notas.",
        notesClose: "Cerrar",
        protocol: "Protocolo",
        rating: "Valoración",
        settingsTitle: "Calidad de la atención",
        requireReason: "Exigir motivo al cerrar",
        reasonsTitle: "Motivos de cierre",
        reasonName: "Nuevo motivo",
        reasonAdd: "Agregar",
        reasonInactive: "inactivo",
        reasonHide: "Desactivar",
        reasonShow: "Reactivar",
        reasonDelete: "Eliminar",
        ratingEnabled: "Pedir valoración (1 a 5) al cerrar",
        ratingMessage: "Mensaje de valoración",
        ratingHelp: "Use {{protocol}} para el protocolo y {{name}} para el nombre. Vacío usa el texto predeterminado.",
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            botOn: "Bot activado",
            botOff: "Bot desactivado",
            botTurnOff: "Desactivar el bot y tomar la conversación",
            botTurnOn: "Activar el bot en este ticket",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_FUNNEL_TITLE: "Indique el título de la oportunidad (hasta 120 caracteres).",
        ERR_FUNNEL_VALUE: "Indique un valor válido, desde cero.",
        ERR_FUNNEL_NOTES: "Las observaciones pueden tener hasta 2000 caracteres.",
        ERR_FUNNEL_DUE: "Indique una fecha y hora válidas.",
        ERR_FUNNEL_COLOR: "Elija un color válido.",
        ERR_FUNNEL_KIND: "Tipo de etapa inválido.",
        ERR_FUNNEL_STALE_DAYS: "Indique entre 1 y 365 días, o déjelo vacío.",
        ERR_FUNNEL_STAGE_NAME: "Indique el nombre de la etapa (hasta 60 caracteres).",
        ERR_FUNNEL_STAGE_NOT_FOUND: "Etapa no encontrada.",
        ERR_FUNNEL_STAGE_HAS_OPPORTUNITIES: "Mueva las oportunidades de esta etapa antes de eliminarla.",
        ERR_FUNNEL_LAST_OPEN_STAGE: "El embudo necesita al menos una etapa en curso.",
        ERR_FUNNEL_REORDER: "No se pudo reordenar las etapas. Actualice la página.",
        ERR_OPPORTUNITY_NOT_FOUND: "Oportunidad no encontrada.",
        ERR_TASK_NOT_FOUND: "Tarea no encontrada.",
        ERR_TASK_TITLE: "Indique el título de la tarea (hasta 160 caracteres).",
        ERR_TASK_DONE: "Valor inválido para la finalización de la tarea.",
        ERR_SCHEDULE_INVALID_BODY: "Escriba el mensaje (hasta 4000 caracteres).",
        ERR_SCHEDULE_INVALID_DATE: "Indique una fecha y hora válidas.",
        ERR_SCHEDULE_PAST: "Elija una hora al menos 1 minuto adelante.",
        ERR_SCHEDULE_TOO_FAR: "La programación puede ser de hasta 1 año.",
        ERR_SCHEDULE_INVALID_RECURRENCE: "Repetición inválida.",
        ERR_SCHEDULE_NOT_FOUND: "Programación no encontrada.",
        ERR_SCHEDULE_NOT_PENDING: "Solo se pueden cancelar mensajes pendientes.",
        ERR_SCHEDULE_NOT_FAILED: "Solo se pueden reintentar mensajes que fallaron.",
        ERR_BULK_EMPTY: "Selecciona al menos una atención.",
        ERR_BULK_LIMIT: "Selecciona como máximo 200 atenciones a la vez.",
        ERR_BULK_INVALID_ACTION: "Acción inválida.",
        ERR_BULK_TARGET_REQUIRED: "Elige un agente o una cola de destino.",
        ERR_BULK_INVALID_TARGET: "Agente o cola de destino no encontrado.",
        ERR_CLOSE_REASON_REQUIRED: "Elija el motivo del cierre.",
        ERR_CLOSE_REASON_INVALID: "Motivo de cierre inválido o desactivado.",
        ERR_CLOSE_REASON_INVALID_NAME: "Indique un nombre de hasta 80 caracteres.",
        ERR_CLOSE_REASON_DUPLICATED: "Ya existe un motivo con ese nombre.",
        ERR_CLOSE_REASON_NOT_FOUND: "Motivo no encontrado.",
        ERR_NOTE_INVALID: "Escriba la nota (hasta 2000 caracteres).",
        ERR_NOTE_NOT_FOUND: "Nota no encontrada.",
        ERR_TAG_NOT_FOUND: "Etiqueta no encontrada.",
        ERR_TAG_NAME_IN_USE: "Ya existe una etiqueta con ese nombre.",
        ERR_TAG_INVALID_NAME: "Indica el nombre de la etiqueta (hasta 40 caracteres).",
        ERR_TAG_TOO_MANY: "Límite de 20 etiquetas por contacto.",
        ERR_CAMPAIGN_NOT_FOUND: "Campaña no encontrada.",
        ERR_CAMPAIGN_INVALID_STATE: "Esta acción no es posible en el estado actual de la campaña.",
        ERR_CAMPAIGN_CONNECTION_BUSY: "Ya hay otra campaña enviando por esta conexión. Páusala o termínala antes.",
        ERR_CAMPAIGN_NO_RECIPIENTS: "No hay destinatarios válidos para esta campaña.",
        ERR_CAMPAIGN_NO_RECIPIENTS_OPT_OUT: "Todos los contactos elegidos pidieron no recibir campañas.",
        ERR_LAB_INVALID_NAME: "Indique un nombre para el escenario.",
        ERR_LAB_INVALID_TURNS: "Indique de 1 a 6 mensajes del cliente (hasta 500 caracteres cada uno).",
        ERR_LAB_INVALID_EXPECT: "Revise los criterios del escenario.",
        ERR_LAB_NOT_FOUND: "Registro del laboratorio no encontrado.",
        ERR_LAB_RUN_BUSY: "Ya hay una prueba en curso.",
        ERR_LAB_NO_SCENARIOS: "Ningún escenario seleccionado.",
        ERR_HERMES_NOT_CONFIGURED: "La integración con Rose no está configurada (HERMES_WEBHOOK_URL).",
        ERR_BUSINESS_HOURS_INVALID: "Horario de atención inválido.",
        ERR_BUSINESS_HOURS_TIMEZONE: "Zona horaria inválida.",
        ERR_BUSINESS_HOURS_TIME: "Horarios inválidos: use HH:MM con apertura antes del cierre.",
        ERR_BUSINESS_HOURS_HOLIDAY: "Feriados inválidos: use fechas reales AAAA-MM-DD.",
        ERR_BUSINESS_HOURS_NO_DAYS: "Marque al menos un día de atención.",
        ERR_CAMPAIGN_TOO_MANY_RECIPIENTS: "Demasiados destinatarios para una campaña (máximo 5000).",
        ERR_CAMPAIGN_INVALID_NAME: "Indica un nombre para la campaña.",
        ERR_CAMPAIGN_INVALID_MESSAGE: "Indica el mensaje (hasta 3000 caracteres).",
        ERR_CAMPAIGN_INVALID_CONNECTION: "Conexión inválida.",
        ERR_CAMPAIGN_INVALID_SETTINGS: "Revisa el ritmo de envío: pausas o límite por hora fuera de rango.",
        ERR_CAMPAIGN_DELAY_TOO_LOW: "La pausa mínima entre mensajes es de 15 segundos.",
        ERR_CAMPAIGN_INVALID_WINDOW: "Revisa el horario: indica un inicio y un fin distintos (HH:MM).",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_NO_TICKET_ACCESS: "No tienes acceso a este ticket.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
